import translate from "@insite/client-framework/Translate";
import Select, { SelectPresentationProps } from "@insite/mobius/Select";
import React from "react";
import { css } from "styled-components";
import { SortType } from "@thkStore/Types/VariantChildrenGridModel";

interface Props {
    sortType: SortType;
    onSortChange: (sortType: SortType) => void;
}

export interface VariantChildrenGridSortSelectStyles {
    select?: SelectPresentationProps;
}

export const sortSelectStyles: VariantChildrenGridSortSelectStyles = {
    select: {
        labelProps: {
            css: css`
                width: unset;
            `,
        },
        cssOverrides: {
            formField: css`
                width: 325px;
            `,
        },
    },
};

const styles = sortSelectStyles;

export const VariantChildrenGridSortSelect = ({ sortType, onSortChange }: Props) => {
    const onChangeSortHandler = (event: React.ChangeEvent<HTMLSelectElement>) => {
        onSortChange(event.currentTarget.value as SortType);
    };

    return (
        <Select
            {...styles.select}
            label={translate("Sort by")}
            value={sortType}
            labelPosition="left"
            preventEllipsis={true}
            onChange={onChangeSortHandler}
            data-test-selector="variantChildrenGridSortSelect"
        >
            <option key="BestMatch" value="BestMatch">
                {translate("Best Match")}
            </option>
            <option key="ProductAToZ" value="ProductAToZ">
                {translate("Product: A to Z")}
            </option>
            <option key="ProductZToA" value="ProductZToA">
                {translate("Product: Z to A")}
            </option>
        </Select>
    );
};
